import { render, staticRenderFns } from "./RoleWallet.vue?vue&type=template&id=193746b2&"
import script from "./RoleWallet.vue?vue&type=script&lang=js&"
export * from "./RoleWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports